<template>
  <div class="grid-wrapper grid grid-cols-6 gap-y-8 gap-x-6 laptop:grid-cols-8 laptop:gap-y-10">
    <EnvironmentParagraphNextImages
      class="order-2 laptop:order-1"
      :title="data?.companyPage?.data?.attributes?.water_title || ''"
      :text="data?.companyPage?.data?.attributes?.water_description || ''"
    />
    <div
      class="order-1 col-span-6 col-start-1 mx-auto w-full max-w-[100%] tablet:max-w-[60%] laptop:order-2 laptop:col-span-3 laptop:col-start-6 laptop:mx-0 laptop:max-w-full"
    >
      <div class="relative flex h-0 items-center justify-center pt-[100%]" ref="waterTreatmentContainer">
        <img
          class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
          src="/images/company/empty-circle.png"
          alt=""
        />
        <img
          class="water-treatment-img absolute top-1/2 left-1/2 h-full w-full -translate-x-1/2 -translate-y-1/2"
          src="/images/company/sea.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useWaitForPageTransitionEnd } from "~~/composables/waitPageTransition";
import { Companypage2DataKey } from "~/symbols/symbols";
const data = inject(Companypage2DataKey);
const { promise } = useWaitForPageTransitionEnd();

let tween = null;

onMounted(() => {
  initAnimation();
});
onBeforeUnmount(() => {
  // ScrollTrigger.killAll();
  if (tween) {
    tween.kill;
    tween = null;
  }
});

async function initAnimation() {
  await promise.value;

  tween = gsap.to("html", {
    scrollTrigger: {
      trigger: waterTreatmentContainer.value,
      scrub: 2,
      start: "top 80%",
      end: "bottom 50%",
    },
    "--water-treatment-scale": 1,
  });
}

const waterTreatmentContainer = ref<HTMLElement | null>(null);
</script>
<style>
:root {
  --water-treatment-scale: 0;
  --water-treatment-opacity: 0;
}
</style>
<style lang="scss" scoped>
.water-treatment-img {
  transform: scale(var(--water-treatment-scale)) translateX(-50%) translateY(-50%);
  transform-origin: top left;
}
</style>
